<template>
    <div id="race-course-body" class="row no-gutters h-100">
        <div class="col-12">
            <div class="row no-gutters justify-content-center align-items-center race-course-header-wrapper">
                <div class="col-12 col-sm-6 mt-4 mt-xl-0 justify-content-center align-items-center justify-content-xl-end race-course-header">
                    <div class="row no-gutters justify-content-center align-items-center no-gutters race-course-header-title">
                        <img class="col-3 col-xl-4 race-course-icon" src="../assets/images/racetrack-fairview-poly.svg"/>
                        <div class="col-8 col-xl-8">
                            <h1 class="text race-course-header-main-title">Fairview</h1>
                            <span class="text race-course-header-subtitle text-nowrap">Course - Turf & Sand</span>
                        </div>
                    </div>
                </div>
                <img :src="getImage('racecourse-fairview-poly', 'svg')" class="col-12 col-sm-6 my-4 p-xl-5 d-flex justify-content-center align-items-center race-course-header-img">
            </div>
            <div class="race-course-body d-flex row no-gutters mt-xl-5">
                <div class="col-12 col-xl-7 pt-5 px-3 mb-3 ml-3 race-course-body-item">
                    <span class="race-course-info-header">Port Elizabeth’s only horse racecourse.</span><br>
                    <span class="race-course-info-header">Turf track and now the newly installed Poly Track.</span>
                    <div v-bind:class="{collapseRaceCourseDetails: areRaceCourseDetailsCollapsed}" class="race-course-description my-4">
                        Fairview Racecourse, is managed and maintained by Phumelela Gaming and Leisure Limited. Racing takes place every Friday afternoon and some occasional week days. Situated in Greenbushes, the racecourse boasts a turf track as well as a polytrack which allows racing to take place in most weather conditions.<br><br>
                        Horseracing is a hugely popular sport in South Africa, with regular racing taking place around the country. The sport in South Africa enjoys a long and rich history that can be traced back to 1797, with the first recorded race club meeting taking place in 1802.<br><br>
                        Prior to 1850, irregular thoroughbred horseracing took place in Port Elizabeth but it was officially started in 1857, when the Port Elizabeth Turf Club was formed. In order to establish set rules for racing, in 1882 the Jockey Club of South Africa was also founded in Port Elizabeth.<br><br>
                        The old Fairview Racecourse, previously the Port Elizabeth Turf Club, was situated where the Greenacres Shopping Centre is today. The current Fairview Race Course is in Greenbushes and celebrates it’s 40th Birthday on 18 June 2017. Apart from the new stabling complex, Fairview boasts a number of training tracks and facilities and is also the Head Office for Phumelela Gaming & Leisure Ltd in the Eastern Cape
                    </div>
                    <div class="row no-gutters justify-content-center align-items-center">
                        <button id="read-more-button" v-on:click="onExpandRacecourseDetailsButtonClicked()" class="race-course-btn read-more-btn py-1 mb-1">READ MORE</button>
                    </div>
                    <div class="row no-gutters justify-content-center align-items-center">
                        <button class="d-block race-course-btn next-race-card-btn mt-4">VIEW NEXT RACECARD</button>
                    </div>
                </div>
                <div class="col-12 col-xl-4 mt-3 race-course-body-item">
                    <div class="row no-gutters">
                        <div id="race-course-google-map" class="google-map"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {googleMapsOptions} from "../components/configuration/googleMapsOptions.constant";

    export default {
        name: 'RaceCourse',
        data: function() {
            return {
                areRaceCourseDetailsCollapsed: true
            };
        },
        mounted: function () {
            
        },
        methods: {
            getImage(imagePath, type) {
                return require('../assets/images/' + imagePath + '.' + type);
            },
            onExpandRacecourseDetailsButtonClicked() {
                this.areRaceCourseDetailsCollapsed = !this.areRaceCourseDetailsCollapsed;
                if (this.areRaceCourseDetailsCollapsed) document.querySelector('#read-more-button').innerHTML = 'READ MORE';
                else document.querySelector('#read-more-button').innerHTML = 'READ LESS';
            },
            setRaceCourseDetailsState() {
                this.areRaceCourseDetailsCollapsed = true;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #home-page {
        background: none;
    }

    #race-course-body {
        overflow-y: scroll;
    }

    h1 {
        font-size: 3rem;
        font-weight: bold;
        margin-bottom: 0 !important;
    }

    span {
        font-weight: bold;
    }

    .race-course-icon {
        width: 150px !important;
    }

    .race-course-header-wrapper {
        background-color: #DCDCDC;
        opacity: 0.9;
        top: 0;
        width: 100%;
    }

    .race-course-header {
        text-align: center;
        display: flex;
        z-index: 2;
    }

    .race-course-header-title {
        text-align: center;
    }

    .race-course-header-title {
        font-size: 0.8rem;
    }

    .race-course-header-main-title {
        font-size: 2rem;
        color: black;
        font-weight: 900;
    }

    .race-course-header-subtitle {
        font-size: 0.6rem;
        color: black;
    }

    .race-course-header-img {
        height: 200px;
    }

    .race-course-body {
        background-color: #FFFFFF;
        padding-bottom: 3rem;
        overflow-y: scroll;
        justify-content: center;
    }

    @media (min-width: 576px) {
        .race-course-header-main-title {
            font-size: 2.9rem;
        }

        .race-course-header-subtitle {
            font-size: 1.4rem;
        }
    }

    /* Medium devices (tablets, 1200px and up) */
    @media (min-width: 1200px) {
        p {
            font-size: 1.2rem !important;
        }

        .race-course-btn {
            width: 50%;
            font-size: 1.5rem;
        }

        .race-course-header-main-title {
            font-size: 4.3rem;
        }

        .race-course-header-subtitle {
            font-size: 1.4rem;
        }
    }

    @media (min-width: 1200px) {
        h1 {
            font-size: 5rem;
            font-weight: bold;
        }

        span {
            font-size: 2.5rem;
            font-weight: bold;
        }

        /*.race-course-header-overlay {*/
        /*height: 40vh !important;*/
        /*}*/

        .race-course-header-img {
            height: 100%;
        }

        .race-course-header {
            height: 40vh !important;
        }

        .race-course-header-wrapper {
            height: 40vh;
        }

        .race-course-header-img {
            height: 40vh;
        }

        .race-course-info-header {
            color: #000000;
            font-weight: bolder;
            font-size: 1.5rem;
        }

        .race-course-body {
            height: 60vh;
        }
    }

    .race-course-btn {
        width: 48%;
        border: solid 2px #000000;
        font-size: 0.8rem;
        font-weight: bold;
        border-radius: 4px;
        padding: 0.8rem 0 0.8rem 0;
    }

    .next-race-card-btn {
        background-color: #000000;
        color: #FFFFFF;
    }

    .read-more-btn {
        height: 2.5rem;
        background-color: #FFFFFF;
        color: #000000;
    }

    .race-course-btn:hover {
        cursor: pointer;
    }

    .google-map {
        width: 90%;
        height: 400px;
        margin: 0 auto;
        background: gray;
    }

    .collapseRaceCourseDetails {
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
</style>
